import * as Sentry from "@sentry/react";

export const initSentry = (): void => {
	const { VITE_SENTRY_DSN, VITE_APP_ENVIRONMENT } = import.meta.env;

	if (VITE_APP_ENVIRONMENT !== "production") {
		return;
	}

	Sentry.init({
		dsn: VITE_SENTRY_DSN,
		environment: VITE_APP_ENVIRONMENT,
		integrations: [
			Sentry.browserTracingIntegration(),
			Sentry.replayIntegration({
				networkDetailAllowUrls: ["api.audiowizard.fr"],
			}),
			// Sentry.reactRouterV5BrowserTracingIntegration({ history }),
		],
		tracePropagationTargets: ["https://api.audiowizard.fr"],

		// Set tracesSampleRate to 1.0 to capture 100%
		// of transactions for performance monitoring.
		tracesSampleRate: 0.001,

		// Capture Replay for 10% of all sessions,
		// plus for 100% of sessions with an error
		replaysSessionSampleRate: 0.0,
		replaysOnErrorSampleRate: 0.1,

		// By default, Sentry SDKs normalize any context to a depth of 3.
		// You may want to increase this for sending Redux states.
		normalizeDepth: 10,
	});
};
